import { defineStore } from 'pinia';
import { ref } from 'vue';
import Notification from '@/scripts/helpers/Notification/Notification';
import dropdownEventBus from '@/vue/Event/DropdownEventBus';
import { HIDE_DROPDOWNS_EVENT } from '@/scripts/constants/events';

export const useNotificationStore = defineStore('notification', () => {
    const notification = ref<Notification>(new Notification({
        text: '',
        show: false,
    }));

    const closeOpenDropdowns = (): void => {
        dropdownEventBus.emit(HIDE_DROPDOWNS_EVENT, '');
    };

    const promptUser = (_notification: Notification) => {
        closeOpenDropdowns();
        notification.value = _notification;
    };

    const notifyUser = (text: string) => {
        closeOpenDropdowns();

        const newNotification = new Notification({
            text, withCancel: true,
        });

        newNotification.setCancelButtonText('Ok');

        notification.value = newNotification;
    };

    const hideNotification = () => {
        notification.value = new Notification({
            text: '',
            show: false,
        });
    };

    return {
        notification,
        promptUser,
        notifyUser,
        hideNotification,
    }
})
